import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=38b53d25&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=38b53d25&prod&lang=scss&scoped=true"
import style1 from "./MainView.vue?vue&type=style&index=1&id=38b53d25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b53d25",
  null
  
)

export default component.exports